import moment from "moment";
import UIkit from "uikit";
import React, { useContext, useState, useEffect, useMemo } from "react";

import { AppContexts } from "../../../providers";
import { Image } from "uikit-react";
import ReservationNumber from "../../common/ReservationNumber";
import UnitInfo from "../../messages/unit-info";

import {
  confirmReservation,
  denyReservation,
} from "../../../services/airbnb.service.js";

import { host } from "../../../http";

const AirbnbDetails = ({ thread }) => {
  const { user } = useContext(AppContexts.AuthContext);

  const [updating, setUpdating] = useState(false);
  const [updated, setUpdated] = useState(false);

  const [deny, setDeny] = useState(false);
  const [denyReason, setDenyReason] = useState(null);
  const [denyResponse, setDenyResponse] = useState("");
  const [denyError, setDenyError] = useState([]);

  // I think there's always going to be one
  const reservation = useMemo(() => {
    let source = (thread.sources || []).find((s) => s?.ota === "airbnb");

    console.log(source.thread);
    console.log(source.thread?.reservation);
    console.log((source.thread?.reservation || [])[0]);

    return (source.thread?.reservation || [])[0] || null;
  }, [thread]);

  const address = useMemo(() => {
    let listing = reservation?.listing;

    if (!listing) {
      return "";
    }

    return `${listing.street}, ${listing.city} ${listing.state}. ${listing.zipcode}, ${listing.country_code}`;
  }, [thread]);

  const handleConfirm = async () => {
    setUpdating(true);

    let resp = await confirmReservation(reservation.confirmation_code);

    if (!!resp.error) {
      console.warn("Error Confirming Reservation");
      setUpdating(false);
      return;
    } else {
      setUpdated(true);
      setUpdating(false);
    }
  };

  const handleDeny = async () => {
    if (!deny) {
      setDeny(true);
      return;
    }

    setUpdating(true);

    let resp = await denyReservation(
      reservation.confirmation_code,
      denyReason,
      denyResponse,
    );

    if (!!resp.error) {
      console.warn("Error Confirming Reservation");
      // TODO: Nars we need a popup here
      setUpdating(false);
      return;
    } else {
      setUpdated(true);
      setUpdating(false);
      // TODO: Probably here too
    }
  };

  const reservationRenderer = () => {
    if (!reservation) return null;

    return (
      <div className="guest-chat-info-wrapper uk-active">
        {["cancelled"].includes(reservation.status) && (
          <div className="hms-booking-tag uk-margin-small-top cancelled">
            Cancelled Booking
          </div>
        )}
        <div className="uk-margin-small-top message-text-group">
          <span uk-tooltip="Check-In - Check-Out">
            <Image src="/images/check-in-check-out.svg" />
          </span>
          <div className="chat-value">
            {moment(reservation?.start_date, "YYYY-MM-DD").format(
              "MMM DD, YYYY",
            )}{" "}
            -{" "}
            {moment(reservation?.end_date, "YYYY-MM-DD").format("MMM DD, YYYY")}
          </div>
        </div>
        <div className="uk-margin-small message-text-group">
          <span uk-tooltip="Property ID">
            <Image src="/images/property-id.svg" />
          </span>
          <div className="chat-value">{reservation?.listing?.name}</div>
        </div>
        <div className="uk-margin-small message-text-group">
          <span uk-tooltip="Address">
            <Image src="/images/address.svg" />
          </span>
          <div className="chat-value">{address || ""}</div>
        </div>
        <div className="uk-margin-small message-text-group">
          <span uk-tooltip="Reservation Number">
            <Image src="/images/reservation-number.svg" />
          </span>
          <div className="chat-value">
            {reservation?.confirmation_code || ""}
          </div>
        </div>
        <div className="uk-margin-small message-text-group">
          <span uk-tooltip="Booking Source">
            <Image src="/images/booking-source.svg" />
          </span>
          <div className="chat-value">AirBnB</div>
        </div>
        <div className="uk-margin-small message-text-group">
          <span uk-tooltip="Guest Book">
            <Image src="/images/messages-guestbook.svg" />
          </span>
          <div className="chat-value">
            <a
              href={`https://www.airbnb.com/rooms/${reservation?.listing?.listing_id || ""}`}
              target="_blank"
              rel="noreferrer"
            >
              AirBnB Listing
            </a>
          </div>
        </div>
        {reservation?.status_type === "pending" && !updated && (
          <div className="reservation-actions">
            <div className={`${updating ? "disabled" : ""}`}>
              <h3 className="uk-text-center" style={{ paddingTop: "30px" }}>
                Reservation is pending approval
              </h3>
              <div
                className="uk-button uk-button-# hms-btn hms-red-btn uk-width-1-1 "
                onClick={() => handleConfirm(reservation.confirmation_code)}
              >
                Confirm Reservation
              </div>
              <div
                className={
                  deny && (!denyReason || !denyResponse) ? "disabled" : ""
                }
              >
                <div
                  className="uk-button hms-btn uk-offcanvas-close uk-width-1-1"
                  onClick={() => handleDeny(reservation.confirmation_code)}
                >
                  {deny ? "Confirm Denial" : "Deny Reservation"}
                </div>
              </div>

              {!!deny && (
                <form className="uk-form">
                  <label className="uk-label">Reason For Denial*</label>
                  <select
                    className="uk-select"
                    value={denyReason}
                    onChange={(e) => {
                      setDenyReason(e.target.value);
                    }}
                  >
                    <option value=""></option>
                    <option value="dates_not_available">
                      Dates Not Available
                    </option>
                    <option value="not_a_good_fit">Not A Good Fit</option>
                    <option value="waiting_for_better_reservation">
                      Waiting For A Better Reservation
                    </option>
                    <option value="not_comfortable">Not Comfortable</option>
                  </select>

                  <label className="uk-label">Message To Guest*</label>
                  <textarea
                    className="uk-textarea"
                    value={denyResponse}
                    onInput={(e) => {
                      setDenyResponse(e.target.value);
                    }}
                  ></textarea>
                </form>
              )}
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="uk-card uk-card-default uk-card-small uk-card-body hms-msg-cards hms-booking-info">
      <div className="message-text-group guest-info" uk-grid>
        <span
          className="message-text-group-icon"
          uk-tooltip='title: "Guest"; pos: bottom-left; cls: uk-active contact-tooltip'
        >
          <Image src="/images/guest-active.svg" />
        </span>
        <div className="uk-width-expand">
          <div className="guest-chat-info">
            <div className="chat-guest-value">
              {reservation?.guest?.first_name}
            </div>
          </div>
        </div>
      </div>
      <div>{reservationRenderer()}</div>
    </div>
  );
};

export default AirbnbDetails;
